<section class="page">
  <h2>Position GPS des capteurs</h2>

  @if (loading) {
    <p>Chargement...</p>
  } @else if (error) {
    <div class="error">{{ error }}</div>
  } @else if (capteurs.length === 0) {
    <p>Aucun capteur trouvé.</p>
  } @else {
    <label for="capteur-select">Capteur (numéro de série)</label>
    <select id="capteur-select" [(ngModel)]="selectedCapteur" (change)="onCapteurChange()">
      <option [ngValue]="null" disabled selected hidden>Veuillez sélectionner un capteur</option>
      @for (capteur of capteurs; track capteur.id) {
        <option [ngValue]="capteur">{{ capteur.numero_serie }}</option>
      }
    </select>

    @if (!selectedCapteur) {
      <div class="hint">Veuillez sélectionner un capteur pour modifier sa position.</div>
    }

    @if (selectedCapteur) {
      <form id="position-form" (ngSubmit)="submitPosition()">
        <fieldset [disabled]="positionLoading">
          <legend>Position du capteur</legend>

          @if (positionLoading) {
            <div>Chargement de la position...</div>
          }
          @if (positionError) {
            <div class="error">{{ positionError }}</div>
          }

          <div class="form-group">
            <label for="coordinates">Coordonnées</label>
            <input id="coordinates" name="coordinates" type="text" [(ngModel)]="coordinateInput" placeholder="43.277, 5.405" required />
          </div>

          <fieldset class="mini-form">
            <legend>Zone géographique</legend>
            <div class="form-group checkbox-group">
              <label for="franceMetropolitaine">
                <input
                  id="franceMetropolitaine"
                  name="franceMetropolitaine"
                  type="checkbox"
                  [(ngModel)]="franceMetropolitaine"
                  (change)="onFranceMetropolitaineChange()"
                />
                France métropolitaine
              </label>
            </div>

            @if (franceMetropolitaine) {
              <div class="form-group">
                <label for="departement">Département</label>
                <input
                  id="departement"
                  name="departement"
                  type="text"
                  [(ngModel)]="departement"
                  placeholder="Ex: 33, 2A, 2B"
                  maxlength="3"
                  required
                  pattern="^(0[1-9]|[1-8][0-9]|9[0-5]|2[AaBb])$"
                />
                <div class="hint">Formats acceptés: 01 à 95, 2A ou 2B.</div>
              </div>
            }
          </fieldset>

          <button type="submit">Enregistrer la position</button>
          @if (positionSuccess) {
            <span class="success">{{ positionSuccess }}</span>
          }
        </fieldset>
      </form>

      <fieldset class="geocode-box">
        <legend>Géocodage</legend>
        <div class="form-group">
          <label for="adresse">Adresse</label>
          <input id="adresse" name="adresse" type="text" [(ngModel)]="adresse" placeholder="Ex: 10 rue de Paris, Lyon" />
        </div>
        <div class="hint">Les champs BDD existants restent `latitude` et `longitude`, mais la saisie se fait ici au format `43.277, 5.405`.</div>
        <div class="actions">
          <button type="button" (click)="geocodeAdresse()">Placer le marqueur à l'adresse</button>
          <button type="submit" form="position-form">Enregistrer la position</button>
        </div>
        @if (geocodeError) {
          <div class="error">{{ geocodeError }}</div>
        }
      </fieldset>

      <div id="map"></div>
    }
  }
</section>
